import router from "../router.js";
import store from "./store.js";

let lastTokenCheck = 0;
const CHECK_INTERVAL = 5 * 60 * 1000;

router.beforeEach(async (to, from, next) => {
	if (to.meta.isIframe) {
		return next();
	}

	if (to.path === "/" || to.name === "inviteOffer" || to.name === "LoginSupplier") {
		return next();
	}

	const needReset = localStorage.getItem("needReset") === "true"; // Convertendo para boolean
	if (needReset) {
		return next("/?userAccess=passwordReset"); // Redireciona para a tela de resetar senha
	}

	const requireToken = !!to.matched.some((record) => record.meta.permissionName);

	if (requireToken) {
		const now = Date.now();

		if (now - lastTokenCheck > CHECK_INTERVAL) {
			const authenticated = await store.dispatch("checkToken");
			lastTokenCheck = now;

			if (!authenticated) {
				await store.dispatch("logout");
				return next("/");
			}
		}
	}

	await store.dispatch("getUserInfo");

	next(); // Continua a navegação normalmente
});
